module.exports = __webpack_public_path__ + "img/step3.166258ed.png";